import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from "./i18n";

// import jquery from "./assets/js/jquery.min.js";
// import jcanvas from "./assets/js/jcanvas.min.js";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
